import React, { useState } from "react";
import { Button, Row, Col, Form, Modal, Spinner, Alert } from "react-bootstrap";


const EditSubscriptionNote = ({ show, handleClose, subscription, handleSuccess, noteType }) => {
   
    const [formData, setFormData] = useState({ values: { notes: subscription?.notes?.find(note=>note.type === noteType) ? subscription?.notes?.find(note=>note.type === noteType).notes : " " }, errors: {} });
    const [submitting, setSubmitting] = useState(false);
    const [apiError, setApiError] = useState(undefined);  
    
    const handleChange = (field, value) => {
        setFormData((prevFormData) => {
            const { values: prevValues } = prevFormData;
            return {
                ...prevFormData,
                values: { ...prevValues, [field]: value }
            }
        });
    }

    const onSubmit = async () => {
        const { values: data } = formData;    
       
        const sanitizedData = {
            userSubscriptionId: subscription?.id,
            notes : data ? data?.notes === '' ? " " : data?.notes : " ",
            noteType : noteType,
        };

        try {
            setSubmitting(true);
            setApiError(undefined);           
            await handleSuccess(sanitizedData);
            setSubmitting(false);
        } catch (e) {
            setApiError(e?.message || "System error");
            setSubmitting(false);
            console.log(e)
        }
    }
   
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit Subscription Notes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form >                    
                    <Form.Group as={Row} className="mb-3" controlId="frmNotes">
                        <Form.Label column sm={3}>
                            Notes
                        </Form.Label>
                        <Col sm={9}>
                            <Form.Control
                                type="text" as={'textarea'} rows={2} placeholder=""
                                value={formData?.values?.notes || ''}
                                onChange={(e) => handleChange('notes', e.target.value)}
                                //isInvalid={formData?.errors?.notes}
                            />
                            {formData?.errors?.notes && (<span className="error-text">
                                {formData?.errors?.notes}
                            </span>)}
                        </Col>
                    </Form.Group>                    
                </Form>
                {apiError && (
                    <Alert variant="danger">{apiError}</Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={onSubmit} disabled={submitting}>
                    {submitting && <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />}
                    Update Notes
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default EditSubscriptionNote;